<template>
  <div>
    <div class="darkbg" v-if="darkBg"></div>
    <div :class="(customerClass ? 'block alertdialog ' + customerClass : 'block alertdialog')">
      <div style="text-align:right;">
        <img src="/images/icon_close.png" style="width: 19px; height: 19px; object-fit: cover;" @click="closeWin(0)">
      </div>
      <template v-if="priceUpdate">
        <div class="row childcenter">
          <div class="picture price-update-icon-wrap">
            <img src="/images/price_update_icon.png" class="price-update-icon-combined" alt="" />
          </div>
        </div>
        <div class="row h childcenter title" style="justify-content: center;">{{ title || 'Flight Price Updated' }}</div>
        <div class="content price-update-desc">The fare for your selected flight has changed - book soon!</div>
        <div class="price-compare-box">
          <div class="price-col">
            <div class="price-label">Chosen</div>
            <div class="price-value">{{ originalPrice }}</div>
          </div>
          <div class="price-arrow-col">
                        <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 7h17M12 1l6 6-6 6" stroke="#666666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="none" />
            </svg>
            <div class="price-diff" v-if="priceDiff">{{ priceDiff }}</div>

          </div>
          <div class="price-col">
            <div class="price-label">Now</div>
            <div class="price-value">{{ newPrice }}</div>
          </div>
        </div>
        <div class="insurance-update-divider"></div>
        <div class="insurance-update-note">
          <div class="insurance-update-header">
            <svg class="insurance-update-icon" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" d="M13.81 22H6c-1.11 0-2-.89-2-2V4a2 2 0 0 1 2-2h8l6 6v5.09c-.33-.05-.66-.09-1-.09s-.67.04-1 .09V9h-5V4H6v16h7.09c.12.72.37 1.39.72 2M23 18h-3v-3h-2v3h-3v2h3v3h2v-3h3z" />
            </svg>
            <span class="insurance-update-title">Insurance Coverage Update</span>
          </div>
          <div class="insurance-update-text">
            If you confirm and continue with the updated flight price, we'll automatically recalculate your travel insurance to match your new trip value.
          </div>
        </div>
        <div class="row childcenter btn price-update-btns">
          <div class="button confirm-btn" @click="confirm">{{ confirmBtnTxt }}</div>
          <div class="button select-btn" @click="closeWin(1)">{{ cancelBtnTxt }}</div>
        </div>
      </template>
      <template v-else>
      <div class="row childcenter" v-if="!showInfoLink">
        <div class="picture">
          <img :src="'/images/' + (img != '' ? img : (needConfirm ? 'icon_suc.png' : 'icon_suc.png'))" class="bg" />
        </div>
      </div>
      <div class="row h childcenter title" v-if="title" style="justify-content: center;">{{ title }}</div>
      <div class="row h childcenter" v-if="customerName"
        style="margin:1.5rem 0.1rem; font-size:2rem; font-weight:bolder;justify-content: center;">{{ customerName }}
      </div>
      <div class="row content childcenter" v-if="ishtml(content)" v-html="content"></div>
      <div class="row content childcenter" v-else style="">
        {{ content }}
      </div>
      <div class="row childcenter btn" :class="{ 'btn-without-content': !content }">

        <div :class="'button' + (needConfirm ? ' btn-cancel' : '')" @click="closeWin(1)"
          :style="btnsetting.style ? btnsetting.style : { background: btnsetting.bg, color: btnsetting.color }">
          {{ needConfirm ? cancelBtnTxt : (btnsetting.txt) }}
          <span class='button_desc' v-if="button1Desc != ''">
            {{ button1Desc }}
          </span>
        </div>
        <div class="button btn-box" v-if="needConfirm" @click="confirm"
          :style="{ background: confirmBtnSetting.bg, color: confirmBtnSetting.color, border: confirmBtnSetting.bor }">
          {{ confirmBtnTxt }}</div>
      </div>
      </template>
      <div class="info-link" v-if="showInfoLink">
        <div class="tooltip-container">
          <span @click="handleInfoClick">
            {{ infoLinkText }}
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" style="display: inline-block; vertical-align: middle; margin-left: 4px;">
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5" fill="none"/>
              <path d="M8 7V11M8 5V5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </span>
          <div class="tooltip-content" v-if="showTooltip">
            {{ tooltipContent }}
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- -->
</template>
<script>
import '@/assets/main.css'
import { useI18n } from 'vue-i18n';
import { priceFormat } from '@/utils/tool.js'

export default {
  emits: ['closeWin'],
  components: {},
  props: {
    darkBg: {
      type: Boolean,
      default: true,
    },
    status: {
      type: [String],
      default: 'success' //fail
    },
    title: {
      type: [String],
      default: ''
    },
    customerName: {
      type: [String],
      default: ''
    },
    content: {
      type: [String],
      default: ''
    },
    pagereload: {
      type: Boolean,
      default: false,
    },
    needConfirm: {
      type: Boolean,
      default: false,
    },
    img: {
      type: [String],
      default: ''
    },
    cancelBtnTxt: {
      type: [String],
      default: ''
    },

    button1Desc: {
      type: [String],
      default: ''
    },
    confirmBtnTxt: {
      type: [String],
      default: ''
    },

    btnsetting: {
      type: Object,
      default: {
        txt: '',
        bg: '#00F1BD',
        color: '#000000',

      }
    },
    confirmBtnSetting: {
      type: Object,
      default: {
        txt: '',
        bor: '1px solid #57855f',
        bg: '#57855f',
        color: '#000000'
      }
    },

    customerClass: {
      type: [String],
      default: ''
    },
    showInfoLink: {
      type: Boolean,
      default: false
    },
    infoLinkText: {
      type: [String],
      default: 'More information'
    },
    priceUpdate: {
      type: Object,
      default: {}
    },
    
  },
  computed:{
    originalPrice() {
      if(this.priceUpdate.api?.previous??false){
        const prevPrice = this.priceUpdate.api?.previous??{}
        const prevpersons = prevPrice?.travelerPricings?.length??1;
        const prevtotal = prevPrice?.price?.total??0;
        const cur = prevPrice?.price?.currency??'USD';
        return priceFormat(cur,parseFloat(prevtotal)/prevpersons,'',2,2);
      }
      else{
        return priceFormat(this.priceUpdate.tba.offer.info?.price?.currency??'USD',parseFloat(this.priceUpdate.tba.offer.info?.price?.total??0),'',2,2);
      }
    },
    newPrice() {
      if(this.priceUpdate.api?.current??false){
        const curPrice = this.priceUpdate.api?.current??{}
        const persons = curPrice?.travelerPricings?.length??1;
        const total = curPrice?.price?.total??0;
        const cur = curPrice?.price?.currency??'USD';
        return priceFormat(cur,parseFloat(total)/persons,'',2,2);
      }
      else{
        return priceFormat(this.priceUpdate.tba.offer.info?.price?.currency??'USD',parseFloat(this.priceUpdate.tba.total_price??this.priceUpdate.tba.base_price??0),'',2,2);
      }
    },
    priceDiff() {
      if(this.priceUpdate.api?.previous??false){
        const prevPrice = this.priceUpdate.api?.previous??{}
        const prevpersons = prevPrice?.travelerPricings?.length??1;
        const prevtotal = prevPrice?.price?.total??0;
        const prevcur = prevPrice?.price?.currency??'USD';
        const curPrice = this.priceUpdate.api?.current??{}
        const persons = curPrice?.travelerPricings?.length??1;
        const total = curPrice?.price?.total??0;
        const cur = curPrice?.price?.currency??'USD';
        /*
          //todo: multiple currency 
          if(cur!=prevcur){
              return priceFormat(cur,parseFloat(total)/persons - this.currencyStore.convert(parseFloat(prevtotal)/prevpersons,prevcur,cur),'',2,2);
          }
        */
        return priceFormat(cur,parseFloat(total)/persons - parseFloat(prevtotal)/prevpersons,'',2,2);
      }
      else{
        return priceFormat(this.priceUpdate.tba?.offer?.info?.price?.currency??'USD',parseFloat(this.priceUpdate.tba.total_price??this.priceUpdate.tba.base_price??0)-parseFloat(this.priceUpdate.tba.offer.info?.price?.total??0),'',2,2);
      }
    },
  },
  data() {
    return {
      showTooltip: false,
      tooltipContent: 'TripToGo offers a selection of airlines and airfares for your convenience. For instant purchase airfare, full airfare payment is due at the time of booking. Your ticket confirmation will be sent within 24 to 72 business hours after it has been issued.'
    }
  },
  setup(props) {
      const { t } = useI18n();
    const cancelBtnTxt = props.cancelBtnTxt || (props.priceUpdate ? 'Select another flight' : t("common.close"));
    const confirmBtnTxt = props.confirmBtnTxt || (props.priceUpdate ? 'Confirm & Continue' : t("common.confirm"));

    const btnsetting = {
      ...props.btnsetting,
      txt: props.btnsetting.txt || t("common.closeWindow"),
    };

    const confirmBtnSetting = {
      ...props.confirmBtnSetting,
      txt: props.confirmBtnSetting.txt || t("common.confirm"),
    };

    return {
      t,
      cancelBtnTxt,
      confirmBtnTxt,
      btnsetting,
      confirmBtnSetting,
    };
  },
  created() { },
  methods: {
    ishtml(str) {
      return typeof str === 'string' && /<\/?[a-z][\s\S]*>/i.test(str);
    },
    closeWin(t) {
      let param = this.pagereload ? { pagereload: true } : {};
      if (t <= 0) {
        param = { ...param, close: true };
      }
      this.$emit('closeWin', param);
    },
    confirm() {
      this.$emit('closeWin', { confirm: true })
    },
    handleInfoClick() {
      // Toggle tooltip display
      this.showTooltip = !this.showTooltip;
    }
  }
}
</script>



<style lang="scss" scoped>
.button_desc {
  font-size: 1.3rem;
  font-weight: normal;
  display: block;
  line-height: 1.3rem;
  padding: 0.5rem;
  padding-top: 0;
}

.alertdialog {
  text-align: center;
  color: #333;
  width: 568px;
  top: 50%;
  left: 50%;
  padding: 48px;
  transform: translate(-50%, -50%);
}

.alertdialog .picture {
  width: 10rem;
  height: 10rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 4rem;
  border: 0;
  border-radius: 0;
}

.alertdialog .picture img {
  width: 100%
}

.alertdialog .childcenter {
  font-family: Poppins;
  font-size: 17px;
  font-weight: 700;
  line-height: 30px;
  padding: 0;
  flex-wrap: wrap;
}

.alertdialog .content {
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 3rem;
  margin: 1.7rem 0 3rem;
}

.alertdialog .btn .button {
  font-family: Poppins;
  font-size: 1.7rem;
  font-weight: 700;

  height: auto;
  min-height: 4.4rem;
  border-radius: 0.8rem;
  width: 100%;
  margin-top: 0;
}

.alertdialog .btn-without-content {
  margin-top: 2.6rem;
}

.price-update-icon-wrap {
  margin-bottom: 2.4rem;
}

.price-update-icon-combined {
  width: 9rem;
  height: 9rem;
  color: #1a1a1a;
}

.price-update-desc {
  font-weight: 400;
  margin: 1.2rem 0 2.4rem;
}

.highlight-green {
  margin: 0 0.4rem;
  color: #1a7f4e;
  font-weight: 700;
}

.price-compare-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f7f7f7;
  border: 1px solid #e5e5e5;
  border-radius: 1.2rem;
  padding: 1.6rem 2rem;
  margin-bottom: 2.4rem;
}

.price-compare-box .price-col {
  flex: 1;
}

.price-compare-box .price-label {
  font-family: Poppins;
  font-size: 1.3rem;
  font-weight: 400;
  color: #666666;
  margin-bottom: 0.4rem;
}

.price-compare-box .price-value {
  font-family: Poppins;
  font-size: 1.6rem;
  font-weight: 700;
  color: #333333;
}

.price-arrow-col {
  flex: 0 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 1.6rem;
}

.price-arrow-col .price-diff {
  font-family: Poppins;
  font-size: 1.3rem;
  font-weight: 700;
  color: #1a7f4e;
  margin-bottom: 0.4rem;
  white-space: nowrap;
}

.insurance-update-divider {
  border-top: 1px solid #e5e5e5;
  margin-bottom: 2rem;
}

.insurance-update-note {
  text-align: left;
  margin-bottom: 2.4rem;
}

.insurance-update-header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.6rem;
}

.insurance-update-icon {
  width: 1.8rem;
  height: 1.8rem;
  color: #333333;
  flex-shrink: 0;
}

.insurance-update-title {
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 700;
  color: #333333;
}

.insurance-update-text {
  font-family: Poppins;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 1.9rem;
  color: #666666;
}

.price-update-btns {
  flex-direction: column;
  gap: 1.2rem;
}

.price-update-btns .button {
  margin: 0;
}

.price-update-btns .confirm-btn {
  background: #00f1bd;
  color: #000000;
}

.price-update-btns .select-btn {
  background: #ffffff;
  color: #333333;
  border: 1px solid #d8d8d8;
}

.alertdialog .btn .btn-box {
  margin: 10px 10px 0 10px;
}

.alertdialog .btn .btn-cancel {
  margin: 0 10px;
  background: #2dcde9;
}

.h {
  font-size: 2.4rem !important;
}
.customWin{
  width:650px;
}

.info-link {
  margin-top: 2rem;
  text-align: left;
  font-family: Poppins;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 2rem;
  color: #666;
}

.tooltip-container {
  position: relative;
  display: inline-block;
}

.info-link span {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  transition: color 0.3s ease;
}

.info-link span:hover {
  color: #333;
  text-decoration: underline;
}

.tooltip-content {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 1rem;
  padding: 1.5rem;
  background: white;
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  width: 400px;
  max-width: 90vw;
  font-size: 1.3rem;
  line-height: 2rem;
  color: #333;
  text-align: left;
  z-index: 1000;
}

.tooltip-content::after {
  content: '';
  position: absolute;
  top: 100%;
  left: 2rem;
  border: 8px solid transparent;
  border-top-color: white;
}

@media screen and (max-width: 750px) {
  .alertdialog {
    width: 90%;
    padding: 20px;
  }

  .h {
    font-size: 2rem !important;
  }

  .alertdialog .picture {
    margin: 1.5rem auto;
    width: 6rem;
    height: 6rem;
    margin-bottom:3rem;
    margin-top:0rem;
  }

  .alertdialog .childcenter {
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 700;
    line-height: 2rem;
  }

  .alertdialog .content {
    font-family: Poppins;
    font-size: 1.2rem;
    font-weight: 400;
    line-height: 2rem;
    margin-top: 1.3rem;
  }

  .alertdialog .btn .btn-box {
    margin: 1.5rem 0px;
  }

  .alertdialog .btn .button {
    font-size: 1.5rem;
    min-height: 3.2rem;
    width: 90%;
  }

  .price-update-desc {
    margin: 0.8rem 0 1.6rem;
  }

  .price-compare-box {
    padding: 1.2rem 1rem;
    margin-bottom: 1.6rem;
  }

  .price-compare-box .price-label {
    font-size: 1.1rem;
  }

  .price-compare-box .price-value {
    font-size: 1.4rem;
  }

  .price-arrow-col {
    padding: 0 0.8rem;
  }

  .price-arrow-col .price-diff {
    font-size: 1.1rem;
  }

  .price-update-btns .button {
    width: 100%;
  }

  .info-link {
    margin-top: 1.5rem;
    font-size: 1.2rem;
    line-height: 1.8rem;
  }

  .tooltip-content {
    width: 300px;
    font-size: 1.2rem;
    line-height: 1.8rem;
    padding: 1.2rem;
  }

}
</style>
